// extracted by mini-css-extract-plugin
export default {"select":"optionManagement_select__qPh+H","btn":"optionManagement_btn__LRdnn","input":"optionManagement_input__7fTJi"};